// Latvian translations — mirrors translations.en.js structure.
// Best-effort translation by main agent — please review and refine for native nuance.
export const lv = {
  meta: {
    title: "Toms Skaidro — Apjukums izmaksā dārgi. Skaidrība maina visu.",
  },
  nav: {
    home: "Sākums",
    forStudents: "Skolēniem",
    forBusiness: "Biznesam",
    pricing: "Cenas",
    audit: "Bezmaksas AI audits",
    about: "Par mani",
    contact: "Kontakti",
    cta: "Sazināties",
    menu: "Izvēlne",
    close: "Aizvērt",
  },
  lang: {
    label: "Valoda",
    en: "English",
    lv: "Latviešu",
    short_en: "EN",
    short_lv: "LV",
  },
  common: {
    learnMore: "Uzzināt vairāk",
    readMore: "Lasīt",
    requestLesson: "Pieteikt nodarbību",
    bookAudit: "Pieteikt bezmaksas auditu",
    seeAll: "Skatīt visu",
    next: "Tālāk",
    back: "Atpakaļ",
    submit: "Iesniegt",
    sending: "Sūta…",
    optional: "neobligāti",
    required: "Obligāts",
    seeBusiness: "Apskatīt biznesa pakalpojumus",
    seeStudents: "Apskatīt skolēniem",
    seePricing: "Skatīt cenas",
    fromPrice: "no",
    perHour: "/ h",
    perPack: "/ 4 nodarbības",
    contactMe: "Sazināties",
  },
  home: {
    hero: {
      eyebrow: "Toms Skaidro — autors Toms Reksna",
      title1: "Apjukums izmaksā dārgi.",
      title2: "Skaidrība maina visu.",
      subtitle: "Es esmu Toms Reksna. Es palīdzu skolēniem patiesi izprast fiziku un matemātiku, kā arī palīdzu pieaugušajiem un uzņēmumiem pārvērst AI praktiskā priekšrocībā.",
      tagline: "No fizikas un matemātikas pamatprincipiem līdz AI mācīšanās un biznesa sistēmām.",
      ctaWatch: "Skatīties 90 sekunžu ievadu",
      ctaExplore: "Apskatīt, ko es daru",
    },
    paths: {
      eyebrow: "Divi skaidri virzieni",
      title: "Izvēlies sev piemēroto.",
      description: "Aiz abiem stāv viena pieeja: pamatprincipi, īsta izpratne, praktiska rīcība. Atšķiras tikai auditorija un rezultāts.",
      students: {
        tag: "Skolēniem",
        title: "Privātstundas fizikā, matemātikā un programmēšanā",
        desc: "Individuālas nodarbības, kas veido dziļu, intuitīvu izpratni — nevis algoritmu iekalšanu. No vidusskolas pamatiem līdz augstskolas analīzei un olimpiāžu līmenim. Tagad arī tiešsaistē un angļu valodā.",
        bullets: [
          "Sokrātiska metode — tu domā, es virzu",
          "Reāli rezultāti (skolēni no 4 uz 10, no 3 uz 9)",
          "Latviešu un angļu, tiešsaistē un klātienē",
        ],
        cta: "Apskatīt mācīšanu",
      },
      business: {
        tag: "Biznesam un pieaugušajiem",
        title: "AI apmācības, konsultācijas un pielāgotas sistēmas",
        desc: "Darbnīcas, konsultācijas un izveidoti AI darba plūsmas risinājumi privātpersonām, komandām un pedagogiem. Dati, automatizācija, stāstu veidošana, biznesa attīstība — ar AI kā domāšanas partneri.",
        bullets: [
          "AI darbnīcas un korporatīvās apmācības",
          "Datu analītika un stāstu veidošana ar datiem",
          "Pielāgotas darba plūsmas un automatizācija",
        ],
        cta: "Apskatīt biznesa pakalpojumus",
      },
    },
    intro: {
      eyebrow: "Īsā versija",
      paragraph1: "Es mācos, mācu un veidoju ap vienu jautājumu: kā cilvēki var ātrāk saprast sarežģītas lietas — un labāk izmantot šo izpratni?",
      paragraph2: "Dažreiz tas nozīmē fizikas pasniegšanu. Dažreiz tas nozīmē AI apmācības uzņēmumiem un skolotājiem. Dažreiz tas nozīmē mazu rīku veidošanu, lai pārbaudītu labākus veidus, kā mācīties, domāt un strādāt.",
      videoComing: "90 sekunžu ievads — drīzumā",
      ctaAbout: "Vairāk par mani",
      ctaAudit: "Veikt bezmaksas auditu",
    },
    spotlight: {
      eyebrow: "Šobrīd uzmanības centrā",
      title: "Ko šobrīd publicēju",
      description: "Neliela rotējoša izlase no rakstiem, darbnīcām un eksperimentiem, kas vērti tava laika.",
      cards: [
        {
          tag: "Galvenais raksts",
          title: "Kā AI maina veidu, kā mums būtu jāmācās",
          desc: "Praktisks skatījums uz AI kā domāšanas partneri — bez izpratnes pārliekšanas uz mašīnu.",
          cta: "Lasīt",
        },
        {
          tag: "Tuvākā darbnīca",
          title: "Praktiskā AI mācībām un biznesam",
          desc: "Fokusēta sesija, lai pārvērstu neskaidras AI idejas skaidrās darba plūsmās un mācību sistēmās.",
          cta: "Pievienoties",
        },
        {
          tag: "Eksperiments",
          title: "AI palīdzēta mācīšanās pret tradicionālajiem kursiem",
          desc: "Atklāts eksperiments: vai AI var aizstāt iepriekš ierakstītu kursu kā mācību rīku? Dokumentēts publiski.",
          cta: "Sekot līdzi",
        },
      ],
    },
    closing: {
      eyebrow: "Nezini, ar ko sākt?",
      title: "Ja esi uzņēmums, vienkāršākais sākums ir bezmaksas audits.",
      description: "Piecas īsas anketas atbildes un tavi kontakti. Atbildēšu ar fokusētu nākamo soli dažu darba dienu laikā.",
      cta: "Veikt bezmaksas auditu",
      ctaStudent: "Vai — esmu skolēns",
    },
  },
  forStudents: {
    hero: {
      eyebrow: "Skolēniem — Privātstundas",
      title: "Fizika, matemātika un vairāk — patiesi saprasts.",
      description: "Individuālas nodarbības, kas veido dziļu, intuitīvu izpratni. No vidusskolas fizikas un matemātikas līdz augstskolas analīzei, olimpiāžu sagatavošanai un programmēšanai. Tagad tiešsaistē un pieejams arī angļu valodā.",
    },
    subjects: {
      eyebrow: "Priekšmeti, ko mācu",
      title: "Izvēlies, kas tev vajadzīgs — aptveru plašu spektru.",
      standard: {
        label: "Standarta",
        title: "Vidusskolas fizika un matemātika",
        desc: "Stipru pamatu veidošana, eksāmenu sagatavošana, atzīmju uzlabošana un pārliecības 'es neesmu matemātiķis' kliedēšana.",
        items: ["Fizika (kinemātika → elektromagnētisms)", "Algebra un ģeometrija", "Analīzes ievads", "Statistikas pamati", "Eksāmenu sagatavošana"],
      },
      advanced: {
        label: "Padziļināti",
        title: "Augstskolas un olimpiāžu līmenis",
        desc: "Mērķtiecīgiem skolēniem, kas tiecas augstāk — augstskolas iestājeksāmeni, olimpiādes, tehnisko studiju atbalsts.",
        items: ["Augstskolas analīze un lineārā algebra", "Diferenciālvienādojumi", "Fizikas un matemātikas olimpiādes", "Standartizēto eksāmenu sagatavošana (SAT, A-Level)", "Augstskolas iestājeksāmenu sagatavošana"],
      },
      programming: {
        label: "Programmēšana un zinātne",
        title: "Python, dati, zinātniskie projekti",
        desc: "Skolēniem, kas vēlas tehnisku dziļumu — programmēšana, datu analīze, zinātnisko projektu konsultācijas.",
        items: ["Python programmēšana", "Microsoft Excel (padziļināti)", "Datu analīzes pamati", "Zinātniskās konkursu / projektu konsultācijas", "Programmēšana problēmu risināšanai"],
      },
      extras: {
        label: "Papildus",
        title: "Ārpus nodarbībām",
        desc: "Reizēm nodarbības nav pietiekamas — vai nav īsti tas, ko vajag.",
        items: ["Mājasdarbu un uzdevumu pārskatīšana", "Eksāmenu atbilžu pārbaude", "Pielāgotas uzdevumu kopas ar teoriju", "Iepriekšējo eksāmenu komplekti (pēc pieprasījuma)"],
      },
    },
    method: {
      eyebrow: "Kā es mācu",
      title: "Sokrātiski jautājumi. Pamatprincipi. Īsta izpratne.",
      paragraph1: "Pirms gadiem es pamanīju, ka skolās STEM mācīja arvien algoritmiskāk: ja redzi X, dari Y. Mana pieeja ir pretēja. Es izmantoju jautājumus, lai iesaistītu skolēnu, liktu domāt un nonākt pie atbildes pašam.",
      paragraph2: "Rezultāts ir dziļa intuitīva izpratne — zināt ne tikai, ko darīt, bet patiesi saprast pamatprincipu līmenī, kāpēc tā ir. Tā ir pamats, kas grūtus uzdevumus padara iespējamus.",
      principles: [
        { title: "Pamatprincipi, nevis formulas", desc: "Sākam ar kāpēc, pirms ķeramies pie kā." },
        { title: "Jautājumi pirms atbildēm", desc: "Es virzu. Tu domā. Atbilde ir tava." },
        { title: "Mērķis — intuīcija", desc: "Īsta izpratne kļūst pašsaprotama, kad tā ir sasniegta." },
        { title: "AI kā rīks, nevis kruķis", desc: "Es mācu, kā izmantot AI, lai mācītos ātrāk — bez domāšanas pārliekšanas uz mašīnu." },
      ],
    },
    testimonials: {
      eyebrow: "Ko saka skolēni",
      title: "Reāli rezultāti no reāliem skolēniem.",
      items: [
        { quote: "Pēc semestra ar Tomu manas fizikas atzīmes uzlabojās no 4 uz 10. Viņš nemācīja tikai formulas — viņš lika fizikai beidzot iegūt jēgu.", name: "K. B.", role: "Vidusskolas 12. klase" },
        { quote: "No 3 uz 9 matemātikā. Es nekad nedomāju, ka tas iespējams. Sokrātiskais stils sākumā šķita lēns, bet pēc tam viss vienkārši saslēdzās.", name: "M. L.", role: "11. klases skolēns" },
        { quote: "Toms palīdzēja sagatavoties augstskolas iestājeksāmeniem. Mierīgs, skaidrs un nekad nelika justies muļķīgi par nezināšanu.", name: "A. P.", role: "Inženierzinātņu students" },
        { quote: "Godīgi sakot, pirmais fizikas skolotājs, kurš lika man saprast, KĀPĒC lietas darbojas, nevis tikai iekalt.", name: "L. K.", role: "Fizikas students" },
        { quote: "Viņš palīdzēja man sagatavoties olimpiādēm. Skaidrojumu dziļums ir citā līmenī.", name: "R. S.", role: "Olimpiāžu dalībnieks" },
        { quote: "Pacietīgs, strukturēts un kaut kā padara grūtas lietas pārvaramas. Bez ierunām iesaku.", name: "I. O.", role: "Augstskolas students" },
      ],
    },
    pricing_summary: {
      eyebrow: "Cenas",
      title: "Caurspīdīgas, daudzlīmeņu cenas.",
      description: "Cenas atkarīgas no līmeņa (vidusskola pret augstskola/olimpiāde) un valodas (latviešu vai angļu). 4 iknedēļas nodarbību komplekti ir lētāki par stundu.",
      cta: "Skatīt pilnu cenrādi",
    },
    ai_in_learning: {
      eyebrow: "AI mācībās",
      title: "Es mācu skolēnus izmantot AI, nezaudējot savu domāšanu.",
      paragraph: "AI laikmetā veiksmīgākie skolēni nebūs tie, kas izvairās no AI, ne arī tie, kas ļauj tam izdarīt visu. Viņi būs tie, kas izmanto to kā precīzāku mācību partneri. Es to iekļauju savās nodarbībās, kad tas ir lietderīgi.",
    },
    cta: {
      title: "Gatavs sākt?",
      description: "Atsūti īsu ziņu: kāds priekšmets, kāds līmenis, kad vēlies sākt. Atbildēšu dažu darba dienu laikā.",
      button: "Pieteikt nodarbību",
    },
  },
  forBusiness: {
    hero: {
      eyebrow: "Biznesam un pieaugušajiem",
      title: "AI kā praktiska priekšrocība — nevis teātris.",
      description: "Darbnīcas, konsultācijas un izveidotas sistēmas privātpersonām, komandām un pedagogiem. Palīdzu izgriezties caur troksni un pārvērst AI par kaut ko, ko tavs bizness tiešām izmanto.",
    },
    thesis: {
      eyebrow: "Mans viedoklis",
      title: "Vairums AI stratēģiju izgāžas, jo ir vai nu pārāk neskaidras, vai pārāk rīka formā.",
      paragraph: "Es nepārdodu vēl vienu spožu rīku. Es palīdzu saprast, ko AI patiesi var darīt tavā darbā, izveidot komandas pratību, lai to izmantotu labi, un izgatavot konkrētās darba plūsmas vai sistēmas, kas pārvieto rādītājus. Tad nodrošinu, ka cilvēki var turpināt bez manis.",
    },
    tracks: {
      eyebrow: "Kā es varu palīdzēt",
      title: "Sešas tēmas. Apvienojamas pēc vajadzības.",
      items: [
        {
          title: "AI darbnīcas un korporatīvās apmācības",
          desc: "No AI pamatiem un prompt engineering līdz padziļinātam pielietojumam — lēmumu pieņemšana un problēmu risināšana ar AI. Pusdienas līdz vairāku dienu formāti, pielāgoti tavas komandas reālajam darbam.",
          tag: "Darbnīca",
        },
        {
          title: "AI konsultācijas un individuālā koučošana",
          desc: "Stratēģija bez slaidu šova. Mēs noskaidrojam īsto problēmu, atrodam, kur AI iederas, un definējam konkrētos nākamos soļus. Koučošana pieejama vadītājiem un speciālistiem.",
          tag: "Konsultācijas",
        },
        {
          title: "Datu analītika un Excel + Copilot",
          desc: "Gadiem ilga pieredze. No Excel un PowerPoint pamatiem līdz padziļinātam Copilot, ChatGPT atbalstītai analīzei un palīdzībai cilvēkiem patiesi saprast, ko dati nozīmē.",
          tag: "Dati",
        },
        {
          title: "Stāstu veidošana ar datiem",
          desc: "Atskaites ir vienkāršas. Skaidri komunicēt secinājumus ir grūti. Stāstījumu, prezentāciju un publiskās uzstāšanās veidošana — ar AI palīdzību gan vizuālajā, gan struktūras pusē.",
          tag: "Stāstījums",
        },
        {
          title: "Pielāgoti risinājumi, automatizācija un integrācija",
          desc: "Vieglu AI darba plūsmu, automatizāciju un rīku veidošana, kas iederas tavās esošajās sistēmās. Ieskaitot GDPR, privātumu un drošību.",
          tag: "Izveide",
        },
        {
          title: "Biznesa attīstība un LinkedIn",
          desc: "Lead ģenerācija, klientu izpēte, kontaktu sagatavošana, izstāžu sagatavošana, pārdošanas procesu optimizācija — un LinkedIn profila un Sales Navigator apmācība.",
          tag: "BizDev",
        },
      ],
    },
    text_as_data: {
      eyebrow: "Bonuss — arī teksts ir dati",
      title: "Skaitļi nav vienīgie dati.",
      paragraph: "Tavi LinkedIn ieraksti, izejošās kampaņas, klientu atsauksmes, atsauksmes tiešsaistē, publiskās diskusijas — visi tie ir dati. AI ļauj apkopot, apstrādāt un analizēt tekstu lielā mērogā, lai atrastu, kas patiesi darbojas tavā saturā un sarunās.",
    },
    approach: {
      eyebrow: "Pieeja",
      title: "Trīs varianti katrai sadarbībai.",
      items: [
        { num: "01", title: "Iemācīšu tev pašam", desc: "Tu un tava komanda apgūst prasmi. Es vadu apmācības, kouču un atkāpjos, kad esat gatavi." },
        { num: "02", title: "Uztaisīšu priekš tevis", desc: "Pielāgotas darba plūsmas, rīki vai mācību sistēmas, gatavas lietošanai." },
        { num: "03", title: "Hibrīds — mācīt + būvēt", desc: "Es uzbūvēju pirmo versiju kopā ar tevi, tad apmācu komandu, kā to paplašināt un uzturēt." },
      ],
    },
    audit_cta: {
      eyebrow: "Sāc šeit",
      title: "Bezmaksas, fokusēts 30 minūšu AI audits.",
      description: "Piecas īsas anketas atbildes un tavi kontakti. Es pārskatu tavu situāciju un atbildu ar fokusētu nākamo soli. Bez pārdošanas zvanu sērijas.",
      cta: "Veikt bezmaksas auditu",
    },
    case: {
      eyebrow: "Nesenais darbs",
      title: "FITA — Programmatūras inženierijas kurss",
      description: "Vadīju kursu par programmatūras inženieriju un uzturēšanu, aptverot Agile, OOP, QA, programmatūras arhitektūru, dizaina paraugus, API integrāciju, mikroservisu pamatus, atkļūdošanu un mantoto kodu — ar AI aspektu iestrādātu praktiskajā darbā.",
    },
  },
  pricing: {
    hero: {
      eyebrow: "Cenas",
      title: "Godīgi, daudzlīmeņu, bez pārsteigumiem.",
      description: "Privātstundas cenotas pēc līmeņa un valodas. Biznesa sadarbības tiek mērogotas katram projektam pēc bezmaksas audita.",
    },
    tutoring: {
      eyebrow: "Privātstundas",
      title: "Nodarbības fizikā, matemātikā, programmēšanā.",
      note: "Visas nodarbības notiek tiešsaistē video zvanā. 4 nodarbību komplekti tiek plānoti reizi nedēļā vienā un tajā pašā laikā. Nav atmaksas par izlaistām nodarbībām (atļauta 1 pārplānošana uz komplektu).",
      tiers: [
        {
          name: "Standarta — Latviešu",
          desc: "Vidusskolas fizika un matemātika. Programmēšanas pamati. Eksāmenu sagatavošana.",
          single: "€50",
          pack: "€180",
          packPerHour: "€45/h",
          highlight: false,
          features: ["Vidusskolas fizika un matemātika", "Algebra, analīzes ievads, statistika", "Latviešu valoda", "1 pārplānošana uz 4 nodarbību komplektu"],
        },
        {
          name: "Padziļināti — Latviešu",
          desc: "Augstskolas matemātika/fizika. Olimpiāžu sagatavošana. Padziļināta programmēšana.",
          single: "€65",
          pack: "€240",
          packPerHour: "€60/h",
          highlight: false,
          features: ["Augstskolas analīze un lineārā algebra", "Olimpiāžu sagatavošana", "Padziļināta programmēšana", "Latviešu valoda"],
        },
        {
          name: "Standarta — Angļu",
          desc: "Tāpat kā standarta, angļu valodā. Starptautiskiem skolēniem vai angļu valodas skolām.",
          single: "€70",
          pack: "€260",
          packPerHour: "€65/h",
          highlight: true,
          features: ["Vidusskolas fizika un matemātika", "SAT / A-Level / IB sagatavošana", "Angļu valoda", "1 pārplānošana uz 4 nodarbību komplektu"],
        },
        {
          name: "Padziļināti — Angļu",
          desc: "Augstskolas matemātika/fizika un olimpiādes angļu valodā.",
          single: "€85",
          pack: "€320",
          packPerHour: "€80/h",
          highlight: false,
          features: ["Augstskolas līmeņa priekšmeti", "Olimpiāžu sagatavošana", "Standartizētie testi (padziļināti)", "Angļu valoda"],
        },
      ],
      extras: {
        title: "Papildus",
        items: [
          { name: "Mājasdarbu / uzdevumu pārskatīšana", price: "no €15 / uzdevums" },
          { name: "Iepriekšējo eksāmenu komplekti (teorija + uzdevumi)", price: "no €120 / tēma" },
          { name: "Zinātniskā projekta konsultācija", price: "no €80 / sesija" },
        ],
      },
    },
    business: {
      eyebrow: "Bizness",
      title: "Darbnīcas, konsultācijas, pielāgota izstrāde.",
      description: "Katra sadarbība sākas ar bezmaksas auditu, lai darbs atbilstu reālajai problēmai. Zemāk redzami orientējoši diapazoni — galīgā cena tiek mērogota katram projektam.",
      tiers: [
        { name: "Bezmaksas AI audits", price: "€0", desc: "30 minūšu fokusēta saruna pēc īsas anketas. Bez pārdošanas sērijas.", cta: "Pieteikt auditu", to: "/audit" },
        { name: "AI darbnīca — puse dienas", price: "no €800", desc: "3–4 stundu sesija komandām. Pielāgots saturs, praktiski uzdevumi.", cta: "Sazināties", to: "/contact" },
        { name: "AI darbnīca — pilna diena", price: "no €1500", desc: "Pilnas dienas dziļā darbnīca. Ietver iepriekšēju zvanu pielāgošanai.", cta: "Sazināties", to: "/contact" },
        { name: "Konsultācija / koučošanas sesija", price: "no €250", desc: "Par 90 minūšu darba sesiju. Pieejami komplekti.", cta: "Sazināties", to: "/contact" },
        { name: "Pielāgots risinājums / automatizācija", price: "projekta kotācija", desc: "Pielāgotas darba plūsmas, rīki vai mācību sistēmas.", cta: "Sazināties", to: "/contact" },
        { name: "Uzstāšanās un viesu sesijas", price: "projekta kotācija", desc: "Runas pasākumiem, skolām, uzņēmumiem, kopienām.", cta: "Sazināties", to: "/contact" },
      ],
    },
    note: {
      title: "Par šīm cenām",
      text: "Privātstundu cenas atspoguļo tiešsaistes nodarbības un manu metodiku — mazas grupas, rūpīga sagatavošanās un dziļš darbs ar katru skolēnu. Biznesa cenas atspoguļo reālo apjomu un rezultātu, nevis maksu par stundām.",
    },
  },
  audit: {
    hero: {
      eyebrow: "Bezmaksas AI audits",
      title: "Piecas īsas anketas atbildes. Viens fokusēts nākamais solis.",
      description: "Pastāsti par savu situāciju un par to, ko vēlies, lai AI dara tavā darbā. Es pārskatīšu un atbildēšu ar fokusētu rekomendāciju dažu darba dienu laikā.",
    },
    progress: {
      step: "Solis",
      of: "no",
    },
    steps: [
      {
        q: "Kas vislabāk apraksta tavu situāciju?",
        options: [
          { id: "indie", label: "Pašnodarbinātais profesionālis / konsultants" },
          { id: "small", label: "Maza komanda (2–20 cilvēki)" },
          { id: "mid", label: "Vidējs uzņēmums (20–200)" },
          { id: "large", label: "Liela organizācija (200+)" },
          { id: "educator", label: "Pedagogs / skola" },
          { id: "other_role", label: "Kaut kas cits" },
        ],
      },
      {
        q: "Kur tu redzi vislielāko AI iespēju savā darbā?",
        options: [
          { id: "productivity", label: "Ikdienas produktivitāte un rakstīšana" },
          { id: "data", label: "Dati, analītika, atskaites" },
          { id: "sales", label: "Pārdošana, izejošās kampaņas, mārketings" },
          { id: "learning", label: "Mācīšanās, apmācības, izglītība" },
          { id: "build", label: "Pielāgotas darba plūsmas / automatizācija / rīki" },
          { id: "unsure", label: "Godīgi — vēl nezinu" },
        ],
      },
      {
        q: "Kur tu šobrīd atrodies ar AI?",
        options: [
          { id: "explore", label: "Vienkārši pētu / esmu zinātkārs" },
          { id: "some", label: "Lietoju dažus rīkus (ChatGPT, Copilot)" },
          { id: "comfy", label: "Pārliecināts lietotājs, vēlos doties tālāk" },
          { id: "embedded", label: "AI jau ir mūsu darba plūsmās" },
        ],
      },
      {
        q: "Laika grafiks?",
        options: [
          { id: "ideas", label: "Tikai vācu idejas" },
          { id: "quarter", label: "Šajā ceturksnī" },
          { id: "6mo", label: "Tuvāko 6 mēnešu laikā" },
          { id: "soon", label: "Tik drīz, cik iespējams" },
        ],
      },
    ],
    contact: {
      title: "Pēdējais solis — tavi kontakti.",
      description: "Es personīgi lasu katru pieteikumu un atbildu, kad ir reāla atbilstība.",
      fields: {
        name: "Tavs vārds",
        email: "E-pasts",
        company: "Uzņēmums / organizācija",
        context: "Kaut kas, kas man būtu jāzina? (viens vai divi teikumi pilnīgi pietiek)",
      },
      submit: "Nosūtīt audita pieprasījumu",
    },
    success: {
      title: "Paldies — tavs audita pieprasījums ir saņemts.",
      description: "Pārskatīšu tavas atbildes un sazināšos ar fokusētu nākamo soli. Parasti 2–3 darba dienu laikā.",
      action: "Atpakaļ uz sākumu",
    },
    errors: {
      pickOne: "Lūdzu, izvēlies vienu opciju, lai turpinātu.",
      name: "Lūdzu, norādi savu vārdu.",
      email: "Lūdzu, norādi derīgu e-pastu.",
      generic: "Kaut kas nogāja greizi. Lūdzu, mēģini vēlreiz.",
    },
  },
  about: {
    hero: {
      eyebrow: "Par mani",
      title: "Pedagogs, veidotājs, konsultants — strādāju pie skaidrības.",
      description: "Bāzēts Latvijā. Strādāju ar cilvēkiem visur — AI, fizikas, matemātikas, datu, mācīšanās un biznesa sistēmu jomās.",
    },
    story: {
      eyebrow: "Mans stāsts",
      title: "Cilvēki parasti necīnās tāpēc, ka nav pietiekami gudri.",
      paragraph1: "Es esmu Toms Reksna, pedagogs, konsultants un veidotājs Latvijā. Strādāju AI, fizikas, matemātikas, datu, mācīšanās un biznesa sistēmu jomās.",
      paragraph2: "Mans darbs sākas ar vienkāršu pārliecību: cilvēki parasti necīnās tāpēc, ka nav pietiekami gudri. Viņi cīnās, jo sarežģītība pasniegta slikti, rīki tiek izmantoti nepareizi vai ceļš uz priekšu nav skaidrs.",
      paragraph3: "Lielākā daļa no tā, ko daru — mācīšana, rakstīšana, konsultēšana, veidošana — ir tikai dažādas formas vienam un tam pašam darbam: novērst lieko apjukumu, lai īstais darbs varētu sākties.",
    },
    experience: {
      eyebrow: "Pie kā strādāju",
      title: "Divas savstarpēji saistītas prakses jomas.",
      areas: [
        {
          tag: "Izglītība",
          title: "Privātstundas un mācīšanās",
          desc: "Gadiem ilga privātstundu pieredze fizikā un matemātikā — no vidusskolas pamatiem līdz augstskolas analīzei un olimpiāžu sagatavošanai. Pamatā Sokrāta metode un pamatprincipu domāšana. Arvien vairāk paplašināta ar AI-kā-pasniedzējs metodēm.",
        },
        {
          tag: "Bizness un AI",
          title: "AI darbnīcas, konsultācijas, dati, automatizācija",
          desc: "AI apmācības un konsultācijas uzņēmumiem, profesionāļiem un pedagogiem. Datu analītika un stāstu veidošana ar datiem ir specialitāte jau gadiem. Nesenajos darbos ietilpst programmatūras inženierijas kursa vadīšana FITA.",
        },
      ],
    },
    approach: {
      eyebrow: "Mana pieeja",
      title: "Pieci principi, kas klusi veido visu, ko daru.",
      items: [
        "Pamatprincipi pirms īsceļiem",
        "Izpratne pirms automatizācijas",
        "AI kā domāšanas partneris, nevis domāšanas aizstājējs",
        "Praktiski rīki pretstatā abstraktai teorijai",
        "Skaidri skaidrojumi, reāli piemēri, lietderīgi rezultāti",
      ],
    },
    clarity: {
      eyebrow: "Kāpēc skaidrība ir svarīga",
      title: "Apjukums ir dārgs — kluss, ikdienišķs un masveidā.",
      paragraph1: "Apjukums ir tas, kas notur spējīgus skolēnus pārliecībā, ka viņi 'neder matemātikai'. Tas ir tas, kas liek komandām griezties ap AI stratēģijām, kas nekad nenonāk līdz rezultātam. Tas pārvērš lietderīgus rīkus troksnī.",
      paragraph2: "Skaidrība ir pretējais spēks. Skaidrs skaidrojums, ass jautājums, labi nosaukta problēma — tās ir sviras, kas pārvērš pūles rezultātos.",
    },
    book: {
      eyebrow: "Šobrīd rakstu",
      title: "Grāmata par šo darbu.",
      description: "Daļēji veids, kā aprakstīt savu darbu sev, daļēji pamats sarunām ar AI, daļēji saturs, ko atkārtoti izmantot šajā vietnē. Lēni, joprojām attīstās.",
    },
    social: {
      eyebrow: "Atrodi mani",
      title: "Vietas, kur tiešām publicēju.",
    },
  },
  contact: {
    hero: {
      eyebrow: "Kontakti",
      title: "Pastāsti, pie kā strādā.",
      description: "Privātstundas, darbnīcas, konsultācijas, atsauksmes par laboratoriju vai vienkārši interesants jautājums — es lasu katru ziņu un atbildu, kad ir reāla atbilstība.",
    },
    info: {
      directLine: "Tiešais kontakts",
      responseTime: "Atbildes laiks",
      responseText: "Vairums atbilžu pienāk 2–3 darba dienu laikā. Darbnīcām un konsultācijām, lūdzu, iekļauj īsu piezīmi par to, ko vēlies sasniegt.",
      basedIn: "Bāze",
      basedText: "Latvija (CET / EET). Strādāju ar cilvēkiem visur.",
    },
    fields: {
      name: "Vārds",
      email: "E-pasts",
      interest: "Kas tevi interesē?",
      interestPlaceholder: "Izvēlies vienu",
      message: "Ziņa",
      messagePlaceholder: "Ko mēģini darīt, mācīties vai izveidot? Pāris teikumi pilnīgi pietiek.",
      submit: "Nosūtīt ziņu",
      privacy: "Iesniedzot, piekrīti saņemt atbildi uz norādīto e-pastu.",
    },
    interestOptions: {
      private_lessons: "Privātstundas",
      ai_workshop: "AI darbnīca",
      consulting: "Konsultācijas",
      tool_feedback: "Atsauksmes par rīku",
      speaking_webinar: "Uzstāšanās / vebinārs",
      something_else: "Kaut kas cits",
    },
    success: {
      title: "Ziņa saņemta.",
      description: "Paldies, ka rakstīji. Es to rūpīgi izlasīšu un atbildēšu, kad būs reāla atbilstība.",
      another: "Sūtīt vēl vienu",
    },
    errors: {
      name: "Lūdzu, norādi savu vārdu.",
      email: "Lūdzu, norādi derīgu e-pastu.",
      interest: "Lūdzu, izvēlies, kas tevi interesē.",
      message: "Pievieno īsu ziņu — pat viens teikums palīdz.",
      generic: "Kaut kas nogāja greizi, sūtot ziņu. Lūdzu, mēģini vēlreiz.",
    },
    toast: {
      sent: "Ziņa nosūtīta. Drīz atbildēšu.",
      received: "Ziņa saņemta. Sazināšos.",
    },
  },
  forStudentsForm: {
    title: "Pieteikt nodarbību",
    description: "Pastāsti, kas tev nepieciešams. Atbildēšu dažu darba dienu laikā ar pieejamību un apstiprinājumu.",
    fields: {
      name: "Tavs vārds",
      email: "E-pasts",
      subject: "Priekšmets",
      level: "Līmenis",
      pack: "Komplekts",
      language: "Valoda",
      schedule: "Vēlamie laiki / dienas",
      message: "Vēl kaut kas? (neobligāti)",
      submit: "Nosūtīt pieprasījumu",
    },
    levels: {
      standard: "Standarta (vidusskola)",
      advanced: "Padziļināti (augstskola / olimpiāde)",
      programming: "Programmēšana / Excel / Python",
      extras: "Tikai mājasdarbu pārskatīšana",
    },
    packs: {
      single: "Viena 1 stundas nodarbība",
      four: "4 iknedēļas nodarbību komplekts",
      ongoing: "Ilgstoši — apspriedīsim",
    },
    languages: {
      lv: "Latviešu",
      en: "Angļu",
    },
    subjectsHint: "piem., Fizika, Analīze, Python, SAT sagatavošana",
    schedulePlaceholder: "piem., otrdienas vakari, brīvdienas",
    success: {
      title: "Pieprasījums nosūtīts.",
      description: "Pārskatīšu un atbildēšu 2–3 darba dienu laikā ar pieejamiem laikiem.",
      another: "Sūtīt vēl vienu pieprasījumu",
    },
    toast: {
      sent: "Pieprasījums nosūtīts. Drīz atbildēšu.",
    },
  },
  footer: {
    tagline: "Apjukums izmaksā dārgi. Skaidrība maina visu. Toma Reksnas personīgā platforma par mācīšanos, AI un sistēmu domāšanu — no pamatprincipiem līdz praktiskai rīcībai.",
    explore: "Apskatīt",
    site: "Vietne",
    findMe: "Atrodi mani",
    basedIn: "Bāzēts Latvijā. Strādāju ar cilvēkiem visur.",
    copyrightSuffix: "Visas tiesības aizsargātas.",
    builtWith: "Veidots ar nodomu. Nav SaaS veidne.",
  },
  notFound: {
    eyebrow: "404",
    title: "Šī lapa neeksistē.",
    description: "Saite var būt bojāta vai lapa pārvietota. Mēģini atgriezties uz sākumu.",
    cta: "Atpakaļ uz sākumu",
  },
};
